// extracted by mini-css-extract-plugin
export default {"wrapper":"_78oEsVRU1rjzcC9zfP1K4","link":"cUQ41xKrXYut1cbTpu6Yq b-overlay"};